export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/GetOurOffer.23939eea.svg","height":152,"width":152,"blurWidth":0,"blurHeight":0};